import { InstitutionsWrapper } from '@coinscrap/webapp-core';
import { wrapperDataArrayConversor } from 'utils/wrapperDataArrayConversor';

export const useInstitutions = () => {
  const { institutions } = InstitutionsWrapper.use();

  return wrapperDataArrayConversor(institutions);
};
